import create from "zustand";

export default create((set) => ({
  currentProject: 0,
  currentSlide: 0,
  onProjects: false,
  projects: [],
  showProjects: () => set({ onProjects: true }),
  showIntro: () => set({ onProjects: false }),
  nextProject: () =>
    set((state) => ({
      currentProject: Math.min(
        state.currentProject + 1,
        state.projects.length - 1
      ),
    })),
  prevProject: () =>
    set((state) => ({ currentProject: Math.max(state.currentProject - 1, 0) })),
  setProjects: (projects) => set(() => ({ projects })),
}));
